import React from 'react';
import { Container, Typography, Box, Fade } from '@mui/material';
import { BatteryChargingFull } from '@mui/icons-material';
import GestionCeldas from '../../components/MovilidadElectrica/GestionCeldas';
import { MovilidadElectricaProvider } from '../../context/MovilidadElectricaContext';

const CeldasPage = () => {
  return (
    <Fade in timeout={800}>
      <Container maxWidth="lg" sx={{ py: { xs: 2, sm: 4 } }}>
        {/* Header moderno */}
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: { xs: 1.5, sm: 2 }, 
          mb: { xs: 2.5, sm: 4 }
        }}>
          <Box
            sx={{
              p: { xs: 1.25, sm: 1.5 },
              borderRadius: { xs: 2, sm: 3 },
              background: 'linear-gradient(135deg, #002642 0%, #00577A 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <BatteryChargingFull sx={{ 
              color: '#FFFFFF', 
              fontSize: { xs: '1.75rem', sm: '2rem' } 
            }} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: '#002642',
                fontSize: { xs: '1.375rem', sm: '2rem', md: '2.5rem' },
                mb: { xs: 0.25, sm: 0.5 },
                lineHeight: { xs: 1.2, sm: 1.1 }
              }}
            >
              Gestión de Celdas
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: '#75787B',
                fontSize: { xs: '0.8rem', sm: '1rem' },
                lineHeight: 1.3
              }}
            >
              Administra las celdas de estacionamiento eléctrico
            </Typography>
          </Box>
        </Box>

        {/* Content */}
        <MovilidadElectricaProvider>
          <GestionCeldas />
        </MovilidadElectricaProvider>
      </Container>
    </Fade>
  );
};

export default CeldasPage;
